import { render, staticRenderFns } from "./TciPicDiv.vue?vue&type=template&id=51595193&scoped=true"
import script from "./TciPicDiv.vue?vue&type=script&lang=js"
export * from "./TciPicDiv.vue?vue&type=script&lang=js"
import style0 from "./TciPicDiv.vue?vue&type=style&index=0&id=51595193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51595193",
  null
  
)

export default component.exports